import { API_HOST, getHttpGetOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/approval`;
const getViewApprovalCountEndpoint = (programmeExternalReference) =>
  `${getEndpoint()}/detail/count/${programmeExternalReference}`;
const getViewApprovalMembersEndpoint = (programmeExternalReference) =>
  `${getEndpoint()}/detail/${programmeExternalReference}`;
const getViewApprovalsEndpoint = (programmeExternalReference) => `${getEndpoint()}/view/${programmeExternalReference}`;
const getUpdatePostStatusEndpoint = (programmeExternalReference, postExternalReference) =>
  `${getEndpoint()}/post/${programmeExternalReference}/${postExternalReference}`;
const getUpdateCommentStatusEndpoint = (programmeExternalReference, commentExternalReference) =>
  `${getEndpoint()}/comment/${programmeExternalReference}/${commentExternalReference}`;
const getUpdateAllPostStatusEndpoint = (programmeExternalReference, systemUserExternalReference) =>
  `${getEndpoint()}/posts/${programmeExternalReference}/${systemUserExternalReference}`;
const getUpdateAllCommentsStatusEndpoint = (programmeExternalReference, systemUserExternalReference) =>
  `${getEndpoint()}/comments/${programmeExternalReference}/${systemUserExternalReference}`;
const getViewApprovalsForUserEndpoint = (programmeExternalReference, systemUserExternalReference) =>
  `${getEndpoint()}/view/${programmeExternalReference}/${systemUserExternalReference}`;
const getEvaluateSupportConversationEndpoint = (programmeExternalReference, systemUserExternalReference) =>
  `${getEndpoint()}/contact/${programmeExternalReference}/${systemUserExternalReference}`;

export const getViewApprovalCountRequest = (programmeExternalReference) => [
  getViewApprovalCountEndpoint(programmeExternalReference),
  getHttpGetOptions()
];

export const getViewApprovalMembersRequest = (programmeExternalReference) => [
  getViewApprovalMembersEndpoint(programmeExternalReference),
  getHttpGetOptions()
];

export const getViewApprovalsRequest = (programmeExternalReference, type, status) => [
  getViewApprovalsEndpoint(programmeExternalReference),
  getHttpGetOptions(null, { type, status })
];

export const getUpdatePostStatusRequest = (programmeExternalReference, postExternalReference, status) => [
  getUpdatePostStatusEndpoint(programmeExternalReference, postExternalReference),
  getHttpGetOptions(null, { status })
];

export const getUpdateCommentStatusRequest = (programmeExternalReference, commentExternalReference, status) => [
  getUpdateCommentStatusEndpoint(programmeExternalReference, commentExternalReference),
  getHttpGetOptions(null, { status })
];

export const getUpdateAllPostStatusRequest = (programmeExternalReference, systemUserExternalReference, status) => [
  getUpdateAllPostStatusEndpoint(programmeExternalReference, systemUserExternalReference),
  getHttpGetOptions(null, { status })
];

export const getUpdateAllCommentStatusRequest = (programmeExternalReference, systemUserExternalReference, status) => [
  getUpdateAllCommentsStatusEndpoint(programmeExternalReference, systemUserExternalReference),
  getHttpGetOptions(null, { status })
];

export const getViewApprovalsForUserRequest = (programmeExternalReference, systemUserExternalReference) => [
  getViewApprovalsForUserEndpoint(programmeExternalReference, systemUserExternalReference),
  getHttpGetOptions()
];

export const getEvaluateSupportConversationRequest = (programmeExternalReference, systemUserExternalReference) => [
  getEvaluateSupportConversationEndpoint(programmeExternalReference, systemUserExternalReference),
  getHttpGetOptions()
];
